import React from 'react';

import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from '@mui/material/Snackbar';

const NotificationSnackbar = props => {
    const {notification, onClose} = props;

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose()
    };

    return (
        <Snackbar open={true}
                  onClose={handleClose}
                  anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                  autoHideDuration={6000}>
            <Alert variant="filled"
                   severity={notification.severity}
                   onClose={handleClose}>
                <AlertTitle>{notification.title}</AlertTitle>
                {notification.messages.map((m, i) => <div key={i}>{m}</div>)}
            </Alert>
        </Snackbar>
    );
};

export {NotificationSnackbar}